import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar";
import Notification from "../../../services/Notification";
import {
  checkLogin,
  checkUserPermission,
  getUserActionPermission,
} from "../../../services/CheckUserAccess";

import swal from "sweetalert";
// Interval screen
import Maritalstatus from "./Maritalstatus";
import AddMaritalstatus from "./AddMaritalstatus";
import EditMaritalstatus from "./EditMaritalstatus";

const Index = (props) => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const menukey = "marital-status-entry";

  const [RedirectLogin, setRedirectLogin] = React.useState(true);
  /*   const checkLogin = () => {  
    let token = sessionStorage.getItem("token");
    if (!token) {
      swal({
        title: "Oops!",
        text: 'token expired. Please login again',
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) { 
          window.location.href = process.env.REACT_APP_BASE_NAME+`/login`;
          sessionStorage.clear();
        }
      });
    }
  }; */

  const [hasUserPermission, setHasUserPermission] = React.useState(false);

  if (RedirectLogin) {
    setHasUserPermission(checkUserPermission(menukey)); // To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }

  const permissionType = getUserActionPermission(menukey);

  React.useEffect(() => {
    // checkLogin();
    // checkAccess();
  }, []);

  const [msgObj, setMsgObj] = React.useState({
    isOpen: false,
  });
  const openNoticeModal = (obj) => {
    setMsgObj(obj);
  };
  const closeNoticeModal = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setMsgObj({ isOpen: false });
  };

  return (
    // <div>
    //   <AfterLoginNavbar {...props} />
    //   <div className={`section signup-top-padding ${classes.dispenserContainer}`}>
    //     <Switch>
    // <Route path={`${path}/add`} component={AddMaritalstatus}></Route>
    // 	<Route path={`${path}/edit/:id`} component={EditMaritalstatus}></Route>
    //       <Route path={`${path}/`} component={Maritalstatus}></Route>
    //     </Switch>
    //   </div>
    // </div>

    (hasUserPermission && (<div>
      <AfterLoginNavbar {...props} />
      <div
        className={`section signup-top-padding ${classes.dispenserContainer}`}
      >
        <Switch>
          <Route
            path={`${path}/add`}
            render={(props) => (
              <AddMaritalstatus
                {...props}
                openNoticeModal={openNoticeModal}
                permissionType={permissionType}
              />
            )}
          ></Route>
          <Route
            path={`${path}/edit/:id`}
            render={(props) => (
              <EditMaritalstatus
                {...props}
                openNoticeModal={openNoticeModal}
                permissionType={permissionType}
              />
            )}
          ></Route>
          <Route
            path={`${path}/`}
            render={(props) => (
              <Maritalstatus
                {...props}
                openNoticeModal={openNoticeModal}
                permissionType={permissionType}
              />
            )}
          ></Route>
        </Switch>
        <Notification
          closeNoticeModal={closeNoticeModal}
          msgObj={msgObj}
          {...props}
        ></Notification>
      </div>
    </div>))
  );
};

export default Index;

const useStyles = makeStyles({
  dispenserContainer: {
    backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
    backgroundSize: "cover",
    backgroundPosition: "top center",
    minHeight: "753px",
  },
});
